import { render, staticRenderFns } from "./rt_jm.vue?vue&type=template&id=af65be08&"
import script from "./rt_jm.vue?vue&type=script&lang=js&"
export * from "./rt_jm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports